import AcolorPicker from '@/components/AcolorPicker';
import Aeditor from '@/components/Aeditor';
import AiconSelect from '@/components/AiconSelect';
import AtreeSelect from '@/components/AtreeSelect';
import Aupload from '@/components/Aupload';
import AuploadIcon from '@/components/Aupload/Icon';
import moment from "moment";
import './index.css';

export default {
  name: 'AformItem',
  data() {
    return {
      checked: false,
      pickerOptions: {
        date: {
          shortcuts: [
            { text: '今天', onClick: a => a.$emit('pick', moment().toDate()) },
            { text: '昨天', onClick: a => a.$emit('pick', moment().subtract(1, 'days').toDate()) },
            { text: '上周', onClick: a => a.$emit('pick', moment().subtract(1, 'weeks').toDate()) },
            { text: '上月', onClick: a => a.$emit('pick', moment().subtract(1, 'months').toDate()) },
            { text: '上季', onClick: a => a.$emit('pick', moment().subtract(1, 'quarter').toDate()) },
            { text: '去年', onClick: a => a.$emit('pick', moment().subtract(1, 'years').toDate()) },
            { text: '前年', onClick: a => a.$emit('pick', moment().subtract(2, 'years').toDate()) },
            { text: '清空', onClick: a => a.$emit('pick', undefined) },
          ]
        },
        daterange: {
          shortcuts: [
            { text: '昨天', onClick: a => a.$emit('pick', [moment().subtract(1, 'days').toDate(), new Date()]) },
            { text: '本周', onClick: a => a.$emit('pick', [moment().startOf('weeks').toDate(), new Date()]) },
            { text: '上周', onClick: a => a.$emit('pick', [moment().subtract(1, 'weeks').toDate(), new Date()]) },
            { text: '本月', onClick: a => a.$emit('pick', [moment().startOf('months').toDate(), new Date()]) },
            { text: '上月', onClick: a => a.$emit('pick', [moment().subtract(1, 'months').toDate(), new Date()]) },
            { text: '本季', onClick: a => a.$emit('pick', [moment().startOf('quarter').toDate(), new Date()]) },
            { text: '上季', onClick: a => a.$emit('pick', [moment().subtract(1, 'quarter').toDate(), new Date()]) },
            { text: '今年', onClick: a => a.$emit('pick', [moment().startOf('years').toDate(), new Date()]) },
            { text: '去年', onClick: a => a.$emit('pick', [moment().subtract(1, 'years').toDate(), new Date()]) },
            { text: '清空', onClick: a => a.$emit('pick', undefined) },
          ]
        },
        time: {},
        year: {
          shortcuts: [
            { text: '今年', onClick: a => a.$emit('pick', moment().toDate()) },
            { text: '去年', onClick: a => a.$emit('pick', moment().subtract(1, 'years').toDate()) },
            { text: '前年', onClick: a => a.$emit('pick', moment().subtract(2, 'years').toDate()) },
            { text: '三年前', onClick: a => a.$emit('pick', moment().subtract(3, 'years').toDate()) },
            { text: '四年前', onClick: a => a.$emit('pick', moment().subtract(4, 'years').toDate()) },
            { text: '五年前', onClick: a => a.$emit('pick', moment().subtract(5, 'years').toDate()) },
            { text: '六年前', onClick: a => a.$emit('pick', moment().subtract(6, 'years').toDate()) },
            { text: '七年前', onClick: a => a.$emit('pick', moment().subtract(7, 'years').toDate()) },
            { text: '清空', onClick: a => a.$emit('pick', undefined) },
          ]
        },
        month: {
        },
      },
    }
  },
  destroyed() {
    this.choose = null;
    this.change = null;
    this.filter = null;
    this.create = null;
  },
  methods: {
    choose(a) {
      const { form = {}, field = undefined, data = [], ...r } = this.$attrs;
      let list = [];
      if (a) {
        data.forEach(a => list.push(`${a.values || a.value || a.code || a.val || a.id}`));
        form[field] = list;
        this.change(list);
      } else form[field] = undefined;
      r.choose && r.choose(a, form[field]);
    },
    change(a) {
      const { data = [], ...r } = this.$attrs;
      if (data && data.length > 0) {
        if (a.length == data.length) this.checked = true;
        else this.checked = false;
        this.$forceUpdate();
      }
      r.change && r.change(a, this.filter(a, data));
    },
    filter(value = '', array = []) {
      if (value != '') {
        if (array && array.length > 0) {
          let data = {};
          array.forEach(a => {
            let index = a.values || a.value || a.code || a.val || a.id;
            if (value == index) data = a;
          });
          return data;
        }
      }
    },
    create() {
      const { form = {}, ...r } = this.$attrs;
      if (r.render) return (r.render(this.$attrs));
      const on = { input: a => this.$emit('input', a), ...r, change: this.change };
      const field = r.field || r.index || r.prop || r.name || undefined;
      const style = { ...r.style };
      const label = r.text || r.label || r.title || '';
      const quick = r.shortcuts || r.shortcut || r.quickly || r.quick || r.fast;
      const limit = parseInt((r.maxlength || r.length || r.max || r.maxLength) + 1) || null;
      const attrs = { clearable: true, filterable: true, collapseTags: true, ...r };
      const values = (a = {}) => (typeof a == 'string') ? a : (`${(a.value || a.code || a.val || a.id)}`);
      const labels = (a = {}) => (typeof a == 'string') ? a : (a.label || a.title || a.text || a.name || a.key);
      const colors = (a = {}) => (typeof a == 'string') ? a : (a.colour || a.color || a.theme || a.rgba || a.rgb);
      const type = (r.type && (r.type != '')) ? r.type.toLowerCase() : '';
      if ((type === 'text') || (type === 'input') || (type == 'string')) return (<el-input v-model={form[field]} maxlength={limit} placeholder={`请输入${label}`} style={style} {...{ attrs }} {...{ on }} />);
      if ((type == 'year') || (type == 'years')) return (<el-date-picker type={r.type} v-model={form[field]} align="center" value-format="yyyy" placeholder={`请选择${label}`} picker-options={this.pickerOptions.year} style={style} {...{ attrs }} {...{ on }} />);
      if ((type == 'month') || (type == 'months')) return (<el-date-picker type={r.type} v-model={form[field]} align="center" value-format="yyyy-MM" placeholder={`请选择${label}`} picker-options={this.pickerOptions.month} style={style} {...{ attrs }} {...{ on }} />);
      if ((type === 'mail') || (type === 'email')) return (<el-input v-model={form[field]} placeholder={`请输入${label}`} style={{ maxWidth: '320px', ...style }} {...{ attrs }} {...{ on }} />);
      if ((type == 'image') || (type == 'images')) return (<AuploadIcon v-model={form[field]} src={form[field]} placeholder={`请选择${label}`} style={style} {...{ attrs }} {...{ on }} />);
      if ((type == 'tree') || (type == 'treeselect') || (type == 'selecttree')) return (<AtreeSelect v-model={form[field]} placeholder={`请选择${label}`} style={style} {...{ attrs }} {...{ on }} />);
      if ((type == 'icon') || (type == 'iconselect') || (type == 'selecticon')) return (<AiconSelect v-model={form[field]} placeholder={`请选择${label}`} style={style} {...{ attrs }} {...{ on }} />);
      if ((type == 'theme') || (type == 'color') || (type == 'colour')) return (<AcolorPicker v-model={form[field]} placeholder={`请选择${label}`} style={style} {...{ attrs }} {...{ on }} />);
      if ((type == 'tel') || (type == 'phone') || (type == 'telephone')) return (<el-input v-model={form[field]} placeholder={`请输入${label}`} style={{ maxWidth: '200px', ...style }} {...{ attrs }} {...{ on }} />);
      if ((type == 'editor') || (type == 'article') || (type == 'context')) return (<Aeditor v-model={form[field]} placeholder={`请输入${label}`} style={style} {...{ attrs }} {...{ on }} />);
      switch (type) {
        case 'textarea': return (<el-input v-model={form[field]} maxlength={limit} rows="6" resize="none" placeholder={`请输入${label}`} style={style} {...{ attrs }} {...{ on }} />);
        case 'password': return (<el-input v-model={form[field]} maxlength={limit} placeholder={`请输入${label}`} show-password style={style} {...{ attrs }} {...{ on }} />);
        case 'number': return (<el-input-number v-model={form[field]} min={0} max={10000000000} controls={false} controls-position="right" placeholder={`请输入${label}`} style={{ width: '140px', ...style }} {...{ attrs }} {...{ on }} />);
        case 'select': return (
          <el-select v-model={form[field]} placeholder={`请选择${label}`} style={style} {...{ attrs }} {...{ on }}>
            {quick && r.multiple && (
              <li key="all" class={['a-form-item select el-select-dropdown__item', (this.checked ? 'selected' : null)]}>
                <el-checkbox v-model={this.checked} on-change={this.choose}>全部</el-checkbox>
              </li>
            )}
            {r.data && r.data.length > 0 ? (r.data.map((a, b) => <el-option key={b} label={labels(a)} value={values(a)} />)) : []}
          </el-select>
        );
        case 'cascader': return (<el-cascader v-model={form[field]} options={r.data || []} placeholder={`请选择${label}`} class="a-form-item cascader" style={style} props={{ props: { multiple: false, checkStrictly: true, emitPath: true } }} {...{ attrs }} {...{ on }} />);
        case 'checkbox': return (<el-checkbox v-model={form[field]} style={style} {...{ attrs }} {...{ on }}>{label}</el-checkbox>);
        case 'checkboxgroup': return (
          <el-checkbox-group v-model={form[field]} style={style} {...{ attrs }} {...{ on }}>
            {r.data && r.data.length > 0 ? (r.data.map((a, b) => <el-checkbox key={b} label={values(a)}>{labels(a)}</el-checkbox>)) : []}
          </el-checkbox-group>
        );
        case 'radio': return (
          <el-radio-group v-model={form[field]} style={style} {...{ attrs }} {...{ on }}>
            {r.data && r.data.length > 0 ? (r.data.map((a, b) => <el-radio key={b} label={values(a)}>{labels(a)}</el-radio>)) : []}
          </el-radio-group>
        );
        case 'switch': {
          if (r.data && r.data.length > 0) {
            let opened = r.data[0] || null;
            let closed = r.data[r.data.length - 1] || null;
            if (opened && closed) {
              return (
                <el-switch
                  v-model={form[field]}
                  active-value={values(opened) || '1'}
                  inactive-value={values(closed) || '0'}
                  active-text={labels(opened) || '启用'}
                  inactive-text={labels(closed) || '禁用'}
                  active-color={colors(opened) || '#13ce66'}
                  inactive-color={colors(closed) || '#dcdfe6'}
                  style={style}
                  {...{ attrs }}
                  {...{ on }}
                />
              );
            }
          }
          return (<el-switch v-model={form[field]} active-value="1" inactive-value="0" active-text="启用" inactive-text="禁用" active-color="#13ce66" style={style} {...{ attrs }} {...{ on }} />);
        };
        case 'datetimerange': return (<el-date-picker type={r.type} v-model={form[field]} align="center" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder={`请选择${label}`} start-placeholder="开始时间" end-placeholder="结束时间" picker-options={this.pickerOptions.daterange} style={style} {...{ attrs }} {...{ on }} />);
        case 'daterange': return (<el-date-picker type={r.type} v-model={form[field]} align="center" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder={`请选择${label}`} start-placeholder="开始时间" end-placeholder="结束时间" picker-options={this.pickerOptions.daterange} style={style} {...{ attrs }} {...{ on }} />);
        case 'datetime': return (<el-date-picker type={r.type} v-model={form[field]} align="center" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder={`请选择${label}`} picker-options={this.pickerOptions.date} style={style} {...{ attrs }} {...{ on }} />);
        case 'date': return (<el-date-picker type={r.type} v-model={form[field]} align="center" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder={`请选择${label}`} picker-options={this.pickerOptions.date} style={style} {...{ attrs }} {...{ on }} />);
        case 'time': return (<el-time-picker type={r.type} v-model={form[field]} align="center" value-format="HH:mm:ss" placeholder={`请选择${label}`} picker-options={this.pickerOptions.time} style={style} {...{ attrs }} {...{ on }} />);
        case 'upload': return (<Aupload v-model={form[field]} placeholder={`请选择${label}`} style={style} {...{ attrs }} {...{ on }} />);
        default: return (<el-input v-model={form[field]} maxlength={limit} placeholder={`请输入${label}`} style={style} {...{ attrs }} {...{ on }} />);
      }
    },
  },
  render() {
    return this.create();
  }
}